<template>
	<div class="section">
		<div class="container">
			<div class="columns">
				<div class="column">
					<h2>Login</h2>
					<b-field>
						<b-input @keydown.native="catch_Enter($event)" type="text" placeholder="Email" v-model="form.Email"></b-input>
					</b-field>
					<b-field>
						<b-input @keydown.native="catch_Enter($event)" type="password" placeholder="Password" v-model="form.Password"></b-input>
					</b-field>
					<a @click="$router.push('/forgotPassword')">Forgot password?</a>
					<b-button class="is-primary is-pulled-right" v-bind:class="{'is-loading': loading.Login == true}" @click="login">Login</b-button>
					<div style="margin-top: 40px;" class="columns">
						<div class="column">
							<video src="https://ctc-document.s3.amazonaws.com/promo.mp4" controls>
								Your browser does not support the video tag.
							</video>
						</div>
					</div>
				</div>
				<div class="column">
					<h2>Request access</h2>
					<p>Only participants in the aviation financing and leasing sector may request access to the AWG carbon calculator. Please provide the information requested below. An AWG administrator will review your request and respond.</p>
					<b-field label="Name of organisation requesting access">
						<b-input placeholder="Organisation" v-model="request.Organization"></b-input>
					</b-field>
					<b-field label="First Name of administrator of requesting organisation">
						<b-input placeholder="First name" v-model="request.FirstName"></b-input>
					</b-field>
					<b-field label="Last Name of administrator of requesting organisation">
						<b-input placeholder="Last name" v-model="request.LastName"></b-input>
					</b-field>
					<b-field label="Administrator title within requesting organisation">
						<b-input placeholder="Title" v-model="request.Title"></b-input>
					</b-field>
					<b-field>
						<template slot="label">
							<b>Administrator contact email</b>&nbsp;
							<b-tooltip label="If use is approved this person will be the default administrator for the organisation"
									   position="is-top"
									   multilined>
								<i class="fas fa-question-circle"></i>
							</b-tooltip>
						</template>
						<b-input type="text" placeholder="Email address" v-model="request.PrimaryEmail"></b-input>
					</b-field>
					<b-field>
						<b-checkbox v-model="request.AFLS">Tick this box to confirm that the organisation is a participant in the aviation financing and leasing sector</b-checkbox>
					</b-field>
					<b-field label="Reasoning for access request">
						<b-input type="textarea" placeholder="Reasoning for access request" v-model="request.Reasoning"></b-input>
					</b-field>
					<b-field>
						<template slot="label">
							<b>Name, email address, and title of other intended users of the AWG carbon calculator within the organisation</b>&nbsp;
							<b-tooltip label="Users will need to have email addresses within the same website domain as the primary contact email above"
									   position="is-top"
									   multilined>
								<i class="fas fa-question-circle"></i>
							</b-tooltip>
						</template>
						<RequestInfo ref="requestInfo" @updateUsers="request.Emails = $event"></RequestInfo>
					</b-field>
					<b-button class="is-primary is-pulled-right" v-bind:class="{'is-loading': loading.Request == true}" @click="requestAccess">Submit</b-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import RequestInfo from "@/components/user/requestInfo.vue";
	export default {
		components: {
			RequestInfo
		},
		data() {
			return {
				form: {},
				request: {
					Emails: []
				},
				loading: {
					Login: false,
					Request: false
				}
			}
		},
		methods: {
			catch_Enter(e) {
				if (e.keyCode === 13 && !this.loading.Login) {
					this.login();
				}
			},
			async login() {
				if (this.form.Email && this.form.Password) {
					this.loading.Login = true;
					await this.$store.dispatch("login", { Email: this.form.Email, Password: this.form.Password })
						.then(resp => {
							if (resp == "Invalid Credentials") {
								this.openBadNotification("The login credentials were invalid.");
							} else if (resp == "You are currently disabled.") {
								this.openBadNotification("You are currently Disabled.");
							} else if (resp == "Invalid Username") {
								this.openBadNotification("Your username is not in email form.");
							} else if (resp == "This account has expired.") {
								this.openBadNotification("This account has expired.");
							}
							else if (resp != undefined && resp.Exception === undefined) {
								//only if user has an ACC role
								if (resp.Roles.some(x => x == "e04dc3a9-dbe8-11e9-bfb2-0a8acc259594" || x == "783ef5f4-867f-11eb-bdc7-0a14b8f4c1fd" || x == "eb68cbac-7d1e-11eb-969d-0a8acc259594")) {
									this.$store.getters.bus.$emit('refresh');
									this.$buefy.notification.open({
										duration: 4000,
										message: "Login successful",
										type: 'is-success',
									});
									this.$router.push("/aircraft");
								}
								else {
									this.$store.dispatch("logout");
									this.openBadNotification("Your login credentials were invalid.");
								}
							} else if (resp.Exception.Message != null && resp.Exception.Message === "Username or Password was incorrect.") {
								this.openBadNotification("Your login credentials were invalid.");
							} else if (resp === undefined) {
								this.openBadNotification("An unhandled exception occurred. Please try again later.");
							} else {
								this.openBadNotification("There was an issue contacting the server. Please try again in a few minutes.");
							}
							this.loading.Login = false;
						}).catch(err => {
							this.loading.Login = false;
							this.openBadNotification("An unhandled exception occurred. Please try again later.");
						})
				} else {
					this.openBadNotification("You must enter an email and password.");
				}
			},
			openBadNotification(message) {
				this.$buefy.notification.open({
					duration: 4000,
					message: message,
					type: 'is-danger',
				})
			},
			requestAccess() {
				if (this.request.Reasoning && this.request.PrimaryEmail && this.request.AFLS && this.request.Organization && this.request.FirstName && this.request.LastName) {
					if (this.$refs.requestInfo.newRow && this.$refs.requestInfo.newRow.FirstName && this.$refs.requestInfo.newRow.LastName && this.$refs.requestInfo.newRow.Email && this.$refs.requestInfo.newRow.Title) {
						this.$refs.requestInfo.add();
					}
					this.loading.Request = true;
					this.$http.post("api/authentication/request", this.request)
						.then(resp => {
							if (resp.data.includes("Success")) {
								this.$buefy.notification.open({
									duration: 4000,
									message: resp.data,
									type: 'is-success',
								});
							} else {
								this.openBadNotification(resp.data);
							}
							this.request = {};
							this.$refs.requestInfo.clear();
							this.loading.Request = false;
						}).catch(err => {
							this.loading.Request = false;
							this.openBadNotification("An unhandled exception occurred. Please try again later.");
						})
				} else {
					this.openBadNotification("You must enter an email and a comment.");
				}
			}
		},
		created() {
			if (this.$store.getters.isLoggedIn || localStorage.getItem("CTC_USER"))
				this.$router.push("/aircraft");
		}
	}
</script>
